const heroVisibleLimit = 3;
$(document).ready(function () {
    calcSectionHeight();
});

function calcSectionHeight() {
    $('#sections').attr('style', `--section-h: ${$('#researchList').prop('clientHeight')}px`);
}